import { Component, OnInit } from '@angular/core';
import { Dialogs } from '@m27/common';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

    public testDialog(): void {
        Dialogs.Alert('test alert', () => {
            alert('worked!');
        });
    }
}
